module.exports = __webpack_public_path__ + "img/295833491.0ab310a5.jpg";